/*
 * @Author: Src
 * @Date: 2024-12-17 18:40:18
 * @LastEditTime: 2024-12-25 19:21:28
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/models/shopFieldFactory.ts
 * @Description: 头部注释配置模板
 */
import { EShopField } from '@/common/enum/shop';
import { IShop } from '@/common/interface/shop';
import _ from 'lodash';


export class ShopFieldFactory {
    static init() {
        let spuFields: IShop[] = [];
        spuFields = _.cloneDeep(InitSpuFields);
        return spuFields;
    }
    static numberValidator(
        rule: { [key: string]: string | (() => boolean) },
        value: string,
    ) {
        return !isNaN(+value);
    }

    static categoryValidator(
        rule: { [key: string]: string | (() => boolean) },
        value: any,
    ) {
        return value != null && value.id !== 0;
    }
}

const InitSpuFields: IShop[] = [
    {
        labelName: '城市',
        label: EShopField.city,
        rule: [
            { required: true, message: '请选择城市', trigger: 'change' },
        ],

    },
    {
        labelName: '门店名称',
        label: EShopField.shopName,
    },
    {
        labelName: '营业执照',
        label: EShopField.shopLicense,
        // rule: [
        //     { required: true, message: '请上传营业执照', trigger: 'change' },
        // ],
    },
    // {
    //     labelName: '城市刊例价',
    //     label: EShopField.showPrice,
    // },
    // {
    //     labelName: '入驻费用',
    //     label: EShopField.entranceFee,
    // },
    {
        labelName: '开业时间',
        label: EShopField.businessYear,
        rule: [
            { required: true, message: '请选择开业时间', trigger: 'change' },
        ],
    },
    {
        labelName: '营业时间',
        label: EShopField.businessHours,
        rule: [
            { required: true, message: '请选择营业时间', trigger: 'change' },
        ],
    },
    {
        labelName: '门店收款支付宝实名',
        label: EShopField.alipayName,
        labelWidth: '140px',
        rule: [
            { required: true, message: '请输入门店收款支付宝实名', trigger: 'change' },
        ],
    },
    {
        labelName: '门店收款支付宝账号',
        label: EShopField.alipayAccount,
        labelWidth: '140px',
        rule: [
            { required: true, message: '请输入门店收款支付宝账号', trigger: 'change' },
        ],
    },
    {
        labelName: '门店店长手机号',
        label: EShopField.shopowerPhone,
        labelWidth: '120px',
        rule: [
            { required: true, message: '请输入门店店长手机号', trigger: 'change' },
        ],
    },
    {
        labelName: '平台联系电话',
        label: EShopField.platformPhone,
        rule: [
            { required: true, message: '请输入平台联系电话', trigger: 'change' },
        ],
    },
    {
        labelName: '高德地图poi',
        label: EShopField.poi,
        readonly: true,
    },
    {
        labelName: '老板电话',
        label: EShopField.bossPhone,
        rule: [
            { required: true, message: '请输入老板电话', trigger: 'change' },
        ],
    },
    {
        labelName: '收银员手机号',
        label: EShopField.cashierPhone,
        rule: [
            { required: true, message: '请输入收银员手机号', trigger: 'change' },
        ],
    },
    {
        labelName: '身份证国徽面',
        label: EShopField.nationalEmblemPhotos,
        // rule: [
        //     { required: true, message: '请上传身份证国徽面', trigger: 'change' },
        // ],
    },
    {
        labelName: '身份证人像面',
        label: EShopField.portraitPhotos,
        // rule: [
        //     { required: true, message: '请上传身份证人像面', trigger: 'change' },
        // ],
    },
    // {
    //     labelName: '赠送天数',
    //     label: EShopField.sendTime,
    // },
    // {
    //     labelName: '审核状态',
    //     label: EShopField.auditStatus,
    // },
]
